<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
    >
        <path
            d="M3.16656 6.05577C4.39386 6.05577 5.38878 5.06085 5.38878 3.83355C5.38878 2.60625 4.39386 1.61133 3.16656 1.61133C1.93926 1.61133 0.944336 2.60625 0.944336 3.83355C0.944336 5.06085 1.93926 6.05577 3.16656 6.05577Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.16656 14.3898C4.39386 14.3898 5.38878 13.3948 5.38878 12.1675C5.38878 10.9402 4.39386 9.94531 3.16656 9.94531C1.93926 9.94531 0.944336 10.9402 0.944336 12.1675C0.944336 13.3948 1.93926 14.3898 3.16656 14.3898Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.72217 3.83398H17.0555"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.72217 12.166H17.0555"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
